export default "__VITE_ASSET__42c28729__"